import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Spinner from '~/components/Spinner';

import { loadStart } from './actions';
import { selectError, selectLoading, selectStart } from './selectors';

const mapStateToProps = createStructuredSelector({
  loading: selectLoading,
  error: selectError,
  start: selectStart,
});

const mapDispatchToProps = dispatch => ({
  loadStart: id => dispatch(loadStart(id)),
});

const StartStatistics = ({ id, render, start, loadStart, ...props }) => {
  useEffect(() => {
    if (!start) {
      loadStart(id);
    }
  }, [id, start, loadStart]);

  return <Spinner {...props}>{start && render(start)}</Spinner>;
};

StartStatistics.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['tillstart'])])
    .isRequired,
  render: PropTypes.func.isRequired,
  start: PropTypes.any,
};

StartStatistics.defaultProps = {
  start: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(StartStatistics);
